// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5977b630","513":"e1c6d7b7","703":"a815802e"}[chunkId] + ".chunk.js";
};